<template>
	<div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('name')">
                    <div class="label-as-input">{{ isNotNullValue(formData.name) }}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('program_code')">
                    <div class="label-as-input">{{ isNotNullValue(formData.program_code)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('exam_code')">
                    <div class="label-as-input">{{ isNotNullValue(formData.exam_code)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('weight')">
                    <div class="label-as-input">{{ isNotNullValue(formData.weight)}}</div>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('sort')">
                    <div class="label-as-input">{{ isNotNullValue(formData.sort)}}</div>
                </b-form-group>
            </b-col>
        </b-row>
	</div>
</template>

<script>
// Components

// Services
import GraduateApplicationEvaluationExamService from "@/services/GraduateApplicationEvaluationExamService";

export default {
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formData: {},
            formLoading: false,
        }
    },

    async created() {
        await this.get(this.formId)
    },
    methods: {
        get(id) {
            GraduateApplicationEvaluationExamService.get(id)
                          .then(response => {
                              this.formData = response.data.data;
                          })
                          .catch(e => {
                              this.showErrors(e)
                          })
        },


    }
}
</script>
